import { AppointmentSlotDuration } from '@uplift/api';


export const AppointmentDurationMappingMinutesDuration: Record<number, AppointmentSlotDuration> = {
  15: AppointmentSlotDuration.fifteen,
  20: AppointmentSlotDuration.twenty,
  30: AppointmentSlotDuration.thirty,
  45: AppointmentSlotDuration.forty_five,
  60: AppointmentSlotDuration.sixty,
};


export const AppointmentDurationMappingDurationMinutes: Record<AppointmentSlotDuration, number> = {
  [AppointmentSlotDuration.fifteen]: 15,
  [AppointmentSlotDuration.twenty]: 20,
  [AppointmentSlotDuration.thirty]: 30,
  [AppointmentSlotDuration.forty_five]: 45,
  [AppointmentSlotDuration.sixty]: 60,
};
